import styled from 'styled-components';

import { breakpoints } from '../../constants';

export const ListItemWrapper = styled.li.attrs({
    role: 'button',
})`
    padding: 15px 20px 0;
    cursor: pointer;
    display: inline-flex;

    @media (${breakpoints.mediumMin}) {
        padding: 40px 60px 0 20px;
    }
`;
